"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs_1 = require("../configs/configs");
class RMBHelper {
    isAustraliaDistribution() {
        return (configs_1.configs === null || configs_1.configs === void 0 ? void 0 : configs_1.configs.dimensions.country) === "au" && (configs_1.configs === null || configs_1.configs === void 0 ? void 0 : configs_1.configs.dimensions.brand) === "sub-dis";
    }
}
exports.default = RMBHelper;
